<template>
  <div class="mob-remove-table-fixed">
    <Card shadow>
      <Row>
        <Col style="text-align: left" :sm="16">
          <Form inline style="height: 41px">
            <FormItem label="需要我审批的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_approval" @on-change="tableSearchForm.need_i_build=false;getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
            <!-- <FormItem label="需要我发布的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_build" @on-change="tableSearchForm.need_i_approval=false; getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem> -->
          </Form>
        </Col>
        <Col style="text-align: right" :sm="8">
          <Button
            style="float: right;"
            @click="$router.push({ name: 'operateReleaseFlowAdd' })"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">申请运维流程</Button>
        </Col>
        <Divider/>
        <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
          <FormItem label="标题">
            <Input v-model="tableSearchForm.title" style="min-width: 200px" />
          </FormItem>
          <!-- <FormItem label="发布模块">
            <Select v-model="tableSearchForm.module" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in moduleList" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem> -->
          <FormItem label="申请人">
            <Select v-model="tableSearchForm.applicant" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
            </Select>
          </FormItem>
          <FormItem label="类型">
            <Select v-model="tableSearchForm.type" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in all_type_list" :key="item.key" :value="item.key">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请时间">
            <DatePicker type="daterange" placement="bottom-end" placeholder=""
                        v-model="tableSearchForm.created_at"
                        style="min-width: 200px"
                        @on-change="searchApplicationTimeChange"
                        class="mob-w-100"></DatePicker>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getTableData()">搜索</Button>
            <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
          </FormItem>
        </Form>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"
        @on-sort-change="changeSort"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getOperateReleaseFlow, deleteOperateReleaseFlow } from '@/api/workflow/operate_release_flow'
import { getAllOpsTypes } from '@/api/workflow/ops-flow-type'
import { getModuleAllList } from '@/api/workflow/project'
import { GetALLUsers } from '@/api/user'
import moment from 'moment'
export default {
  name: 'list',
  data () {
    let that = this
    return {
      status: null,
      ordering: null,
      tableLoading: false,
      listError: false,
      table: {
        data: [],
        columns: [
          {
            title: '标题',
            key: 'title',
            align: 'center',
            tooltip: true,
            minWidth: 300
          },
          // {
          //   title: '项目',
          //   key: 'tenant_name',
          //   align: 'center',
          //   tooltip: true,
          //   minWidth: 100
          // },
          // {
          //   title: '发布模块',
          //   align: 'center',
          //   tooltip: true,
          //   minWidth: 100,
          //   render: (h, params) => {
          //     let tags = []
          //     for (let i in params.row.module) {
          //       const module = params.row.module[i]
          //       tags.push(
          //         h('Tag', module.name)
          //       )
          //     }
          //     return h('div', tags)
          //   }
          // },
          // {
          //   title: '版本号',
          //   key: 'version',
          //   align: 'center',
          //   tooltip: true,
          //   minWidth: 100
          // },
          {
            title: '类型',
            key: 'type_name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '优先级',
            key: 'priority_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '申请人',
            key: 'applicant',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.applicant.name ? params.row.applicant.name : params.row.applicant.username)
            }
          },
          {
            title: '申请时间',
            key: 'created_at',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            sortable: 'custom',
            render: (h, params) => {
              if (params.row.status_verbose) {
                return h('Tag', {
                  props: {
                    color: params.row.status_verbose === '审批完成' ? 'green' : 'blue'
                  }
                }, params.row.status_verbose)
              } else {
                return ''
              }
            },
            filters: [
              {
                label: '待审批',
                value: 4
              },
              {
                label: '审批中',
                value: 5
              },
              {
                label: '审批完成',
                value: 3
              },
              {
                label: '无需审批',
                value: 6
              }
            ],
            filterMultiple: false,
            filterRemote (value, row) {
              if (value.length > 0) {
                that.status = value[0]
              } else {
                that.status = null
              }
              that.getTableData()
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'operateReleaseFlowDetail', params: { id: params.row.id }, query: { lastPage: this.table.page } })
                    }
                  }
                }, '详情'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: params.row.status === 4 && (this.$store.state.user.superuser || this.$store.state.user.userId === params.row.applicant.id) ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      tableSearchForm: {
        title: '',
        applicant: '',
        module: '',
        created_at: '',
        created_at_after: '',
        created_at_before: '',
        need_i_approval: false,
        need_i_build: false,
        type: undefined
      },
      moduleList: [],
      userList: [],
      all_type_list: [],
      moment: moment
    }
  },
  created: function () {
    this.getTableData(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
    this.getModuleList()
    this.getAllUserData()
    this.getAllOpsTypes()
  },
  methods: {
    changeSort (column) {
      if (column.key === 'status_verbose') {
        if (column.order === 'asc') {
          this.ordering = 'status'
        } else {
          this.ordering = '-status'
        }
      }
      this.getTableData()
    },
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      let reqParams = {
        size: this.table.size,
        page: this.table.page,
        title: this.tableSearchForm.title,
        applicant: this.tableSearchForm.applicant,
        created_at_after: this.tableSearchForm.created_at_after,
        created_at_before: this.tableSearchForm.created_at_before,
        need_i_approval: this.tableSearchForm.need_i_approval,
        need_i_build: this.tableSearchForm.need_i_build,
        ordering: this.ordering,
        status: this.status
      }
      if (this.tableSearchForm.type) {
        reqParams.type = this.tableSearchForm.type
      }
      if (this.tableSearchForm.module) {
        reqParams.module = this.tableSearchForm.module
      }
      getOperateReleaseFlow(reqParams).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    delete (id) {
      deleteOperateReleaseFlow(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        title: '',
        applicant: '',
        module: '',
        created_at: '',
        created_at_after: '',
        created_at_before: '',
        need_i_approval: this.tableSearchForm.need_i_approval,
        need_i_build: this.tableSearchForm.need_i_build
      }
    },
    // 获取模块列表
    getModuleList () {
      getModuleAllList().then(res => {
        this.moduleList = res.data
      })
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    searchApplicationTimeChange (value) {
      this.tableSearchForm.created_at_after = value[0]
      this.tableSearchForm.created_at_before = value[1]
    },
    // 获取所有类型列表
    getAllOpsTypes () {
      this.all_type_list = []
      let params = {
      }
      getAllOpsTypes(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_type_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
